var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLgwNotbremsungVoraus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 68,
    viewBox: "0 0 48 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.46 46.176)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M32.818,0 L2.262,0 C1.014,0 0,1.015 0,2.262 L0,16.951 C0,18.199 1.015,19.215 2.262,19.215 L32.819,19.215 C34.067,19.215 35.082,18.199 35.082,16.951 L35.082,2.262 C35.081,1.014 34.066,0 32.818,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M32.8179,0.4992 C33.7909,0.4992 34.5809,1.2892 34.5799009,2.2622 L34.5799009,2.2622 L34.5799009,16.9512 C34.5799009,17.9262 33.7909,18.7152 32.8179,18.7152 L32.8179,18.7152 L2.2609,18.7152 C1.2879,18.7152 0.4979,17.9262 0.4979,16.9512 L0.4979,16.9512 L0.4979,2.2622 C0.4979,1.2892 1.2879,0.4992 2.2609,0.4992 L2.2609,0.4992 Z M32.8179,1.3802 L2.2609,1.3802 C1.7749,1.3802 1.3799,1.7752 1.3799,2.2622 L1.3799,2.2622 L1.3799,16.9522 C1.3799,17.4392 1.7749,17.8332 2.2609,17.8332 L2.2609,17.8332 L32.8179,17.8332 C33.3029,17.8332 33.6979,17.4392 33.6979,16.9522 L33.6979,16.9522 L33.6979,2.2622 C33.6979,1.7752 33.3029,1.3802 32.8179,1.3802 L32.8179,1.3802 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M13.0232701,3.29333019 L16.9601009,4.80540923 C17.7502672,5.15805266 18.6174375,5.30068512 19.4784825,5.22455614 L21.8629822,5.01367012 L27.9034229,10.0670593 L27.3390184,11.1013633 C26.4840987,12.6694453 25.3622901,14.3364074 23.6918278,15.1003224 C23.6918278,15.1038225 22.8500338,16.1075 22.8500338,16.1075 L19.4924833,13.2994782 L20.3351523,12.2931756 L18.6576896,10.8887272 L16.1375579,10.4923315 L9.42683211,4.87716298 C9.98773643,3.45171347 11.5934454,2.74467651 13.0232701,3.29333019 Z M8.30126078,6.21808307 L14.3417015,11.2714722 L13.2181428,12.6137924 L7.1785771,7.56040324 L8.30126078,6.21808307 Z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.425 4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M21.575,0 C20.475,0 19.475,0.6 18.975,1.5 L0.375,34 C-0.125,34.899 -0.125,36.1 0.375,37 C0.975,37.899 1.975,38.5 2.975,38.5 L40.075,38.5 C41.175,38.5 42.175,37.899 42.675,37 C43.175,36.1 43.175,34.899 42.675,34 L24.175,1.5 C23.675,0.6 22.675,0 21.575,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B33229",
    d: "M21.575,1 C20.875,1 20.175,1.3 19.875,2 L1.275,34.5 C0.475,35.8 1.475,37.5 2.975,37.5 L40.075,37.5 C41.575,37.5 42.575,35.8 41.775,34.5 L23.275,2 C22.975,1.4 22.275,1 21.575,1 M21.575,5 L38.375,34.5 L4.775,34.5 L21.575,5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M23.575,28.4999 L23.575,32.4999 L19.575,32.4999 L19.575,28.4999 L23.575,28.4999 Z M23.575,12.5 L22.575,26.5 L20.575,26.5 L19.575,12.5 L23.575,12.5 Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLgwNotbremsungVoraus);
export default __webpack_public_path__ + "static/media/icon-lgw_notbremsung_voraus.b3821da3b935fdac95bdc7596e75d9a7.svg";
export { ForwardRef as ReactComponent };